module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/tr-card-drag.d121b2a86bd708202081.gif";